import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { AnalyticsHero } from "@/components/analytics/HeroSection";
import { CapabilitiesSection } from "@/components/analytics/CapabilitiesSection";
import { DashboardPreview } from "@/components/analytics/DashboardPreview";
import { BenefitsSection } from "@/components/analytics/BenefitsSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const Analytics = () => {
  return (
    <ServiceLayout serviceName="Analytics" className="bg-gradient-to-b from-blue-50 to-white">
      <AnalyticsHero />
      <CapabilitiesSection />
      <DashboardPreview />
      <BenefitsSection />
      <ServiceFAQ faqs={serviceFAQs["analytics"]} serviceName="Analytics" />
      <ServiceCTA serviceName="Analytics" />
    </ServiceLayout>
  );
};

export default Analytics;